module.exports = __webpack_public_path__ + "img/2-low.384b4aa3.png";